import React, { useState } from 'react';
import { empresaRequest } from '../../../../../models/empresas/empresas.models';
import { editarDatosEmpresa, registrarEmpresa } from '../../../../../actions/empresas/empresas.actions';
import { Alerta } from '../../../../../helpers/alerts/alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

export type EditarEmpresaFormProps = {
	idEmpresa: number;
	datosEmpresa: empresaRequest,
	onClose: () => void;
}

const exprecionRegularParaLosColores = "#([0-9a-fA-F]{0,6})?$|^rgba?\(\s*(\d{0,3}\s*,\s*){0,2}\d{0,3}(?:\s*,\s*(0|1|0?\.\d{0,3})?)?\s*\)?";
const EditarEmpresaForm: React.FC<EditarEmpresaFormProps> = ({ idEmpresa, datosEmpresa, onClose }) => {

	const [cargando, setCargando] = useState(false);
	const navigate = useNavigate();
	const [formularioEmpresa, setFormularioEmpresa] = useState<empresaRequest>(datosEmpresa);

	React.useEffect(() => {
		setFormularioEmpresa(datosEmpresa);
	}, [datosEmpresa]);

	const handleInputChange = (name: string, value: string) => {

		if (name === "colorPrincipal" || name === "colorSecundario" || name === "colorTexto") {
			if (value.length > 7) {
				Alerta("El color debe contener 6 caracteres hexadecimales.", false);
				return;
			}
		}

		setFormularioEmpresa((prev: any) => ({
			...prev,
			[name]: value
		}));
	};

	const handleFileChange = (name: string, nameBase64: string, esLogo: boolean, event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files && event.target.files[0]) {
			const file = event.target.files[0];
			let timestamp = new Date().getTime();
			const extension = file.name.split('.').pop();
			const fotoPerfilURL = `${esLogo ? 'logo' : 'fondo'}_${timestamp}.${extension}`;

			const reader = new FileReader();
			reader.onload = () => {
				if (reader.result) {
					const base64String = reader.result.toString();
					const cleanBase64 = base64String.substring(base64String.indexOf(",") + 1);

					setFormularioEmpresa((prev: any) => ({
						...prev,
						[name]: fotoPerfilURL,
						[nameBase64]: cleanBase64,
					}));
				}
			};
			reader.readAsDataURL(file);
		}
	};

	function validarFormulario() {
		let esValido: boolean = true;

		if (!razonSocialEmpresa.trim()) {
			esValido = false;
		}

		if (!colorPrincipal.trim()) {
			esValido = false;
		}

		if (!colorSecundario.trim()) {
			esValido = false;
		}

		if (!colorTexto.trim()) {
			esValido = false;
		}

		if (!logoEmpresa.trim()) {
			esValido = false;
		}

		if (!logoEmpresaBase64.trim()) {
			esValido = false;
		}

		if (!imagenPortadaEmpresa.trim()) {
			esValido = false;
		}

		if (!imagenPortadaEmpresaBase64.trim()) {
			esValido = false;
		}

		if (!appID.trim()) {
			esValido = false;
		}

		if (!privateKey.trim()) {
			esValido = false;
		}

		if (!dominio.trim()) {
			esValido = false;
		}

		if (!template.trim()) {
			esValido = false;
		}

		return {
			esValido
		}
	}

	async function editarDatosEmpresaAsync() {

		try {
			setCargando(true);
			const resp = await editarDatosEmpresa(idEmpresa, formularioEmpresa);
			if (resp.success) {
				Alerta(resp.message, true);
				setCargando(false);
				onClose();
				setTimeout(() => {
					navigate('/dashboard/empresas');
				}, 1500);
			} else {
				Alerta(resp.message, false);
			}
			
		} catch (err) {
			console.log("Ocurrio un error: " + err)
		}
	}

	const {
		razonSocialEmpresa,
		logoEmpresa,
		logoEmpresaBase64,
		imagenPortadaEmpresa,
		imagenPortadaEmpresaBase64,
		colorPrincipal,
		colorSecundario,
		colorTexto,
		telefonoOrigen,
		appID,
		privateKey,
		dominio,
		template,
		idDominio
	} = formularioEmpresa;

	return (
		<form 
			onSubmit={(e)=>{
				e.preventDefault();
				editarDatosEmpresaAsync();
			}}
		>
			{/* Inputs principales */}
			<div className='grid grid-cols-2 text-black lg:text-sm text-xs gap-4 pt-4'>
				<div className='form-control w-full'>
					<label className='label'>
						<span className='label-text font-semibold'>
							Razón social *
						</span>
					</label>
					<input
						type="text"
						required
						value={razonSocialEmpresa}
						id="razonSocialEmpresa"
						name="razonSocialEmpresa"
						className='input input-bordered w-full'
						placeholder='Ej: Empresa SA de CV'
						onChange={(e) => handleInputChange("razonSocialEmpresa", e.target.value)}
					/>
				</div>
				<div className='form-control w-full'>
					<label className='label'>
						<span className='label-text font-semibold'>
							Color principal (hex) *
						</span>
					</label>
					<input
						type="text"
						required
						pattern={exprecionRegularParaLosColores}
						value={colorPrincipal}
						id="colorPrincipal"
						name="colorPrincipal"
						className='input input-bordered w-full'
						placeholder='Ej: #000000'
						onChange={(e) => handleInputChange("colorPrincipal", e.target.value)}
						
					/>
				</div>
				<div className='form-control w-full'>
					<label className='label'>
						<span className='label-text font-semibold'>
							Color secundario (hex) *
						</span>
					</label>
					<input
						type="text"
						required
						pattern={exprecionRegularParaLosColores}
						value={colorSecundario}
						id="colorSecundario"
						name="colorSecundario"
						className='input input-bordered w-full'
						placeholder='Ej: #111111'
						onChange={(e) => handleInputChange("colorSecundario", e.target.value)}
						
					/>
				</div>
				<div className='form-control w-full'>
					<label className='label'>
						<span className='label-text font-semibold'>
							Color del texto (hex) *
						</span>
					</label>
					<input
						type="text"
						required
						pattern={exprecionRegularParaLosColores}
						value={colorTexto}
						id="colorTexto"
						name="colorTexto"
						maxLength={7}
						className='input input-bordered w-full'
						placeholder='Ej: #010101'
						onChange={(e) => handleInputChange("colorTexto", e.target.value)}
						
					/>
				</div>
			</div>
			{/* Logo */}
			<div>
				<label className='label'>
					<span className='label-text font-semibold'>
						Sube un logotipo
					</span>
				</label>
				<div className='flex flex-col justify-center align-middle items-center border-dashed border-2 p-5 gap-2'>
					<div>
						<FontAwesomeIcon icon={faImage} color='#2d6bcf' size='3x' />
					</div>
					<p className='text-sm'>Sube un archivo JPEG, JPE o PNG con un peso máximo de 3MB</p>
					<input
						type="file"
						className="file-input file-input-bordered file-input-xs w-full max-w-xs"
						onChange={(e) => handleFileChange("logoEmpresa", "logoEmpresaBase64", true, e)}
						content={logoEmpresa}
					/>
				</div>
			</div>
			{/* Imagen de portada */}
			<div>
				<label className='label'>
					<span className='label-text font-semibold'>
						Sube una foto de portada
					</span>
				</label>
				<div className='flex flex-col justify-center align-middle items-center border-dashed border-2 p-5 gap-2'>
					<div>
						<FontAwesomeIcon icon={faImage} color='#2d6bcf' size='3x' />
					</div>
					<p className='text-sm'>Sube un archivo JPEG, JPE o PNG con un peso máximo de 3MB</p>
					<input
						type="file"
						className="file-input file-input-bordered file-input-xs w-full max-w-xs"
						onChange={(e) => handleFileChange("imagenPortadaEmpresa", "imagenPortadaEmpresaBase64", false, e)}
						content={imagenPortadaEmpresa}
					/>
				</div>
			</div>
			{/* Configuracion telefono */}
			<div className='pt-2'>
				<div className='p-2 justify-center'>
					<p className=' text-base font-semibold'>Parámetros de configuración: Vonage</p>
				</div>
				<div className='grid grid-cols-2 text-black lg:text-sm text-xs gap-4'>
					<div className='form-control w-full'>
						<label className='label'>
							<span className='label-text font-semibold'>
								Teléfono origen (Vonage)
							</span>
						</label>
						<input
							type="tel"
							value={telefonoOrigen}
							id="telefonoOrigen"
							name="telefonoOrigen"
							pattern="\d{10}"
							className='input input-bordered w-full'
							placeholder='Ej: 55 000 0000'
							onChange={(e) => handleInputChange("telefonoOrigen", e.target.value)}
						/>
					</div>
					<div className='form-control w-full'>
						<label className='label'>
							<span className='label-text font-semibold'>
								AppID (Vonage)
							</span>
						</label>
						<input
							type="text"
							value={appID}
							id="appID"
							name="appID"
							className='input input-bordered w-full'
							placeholder='Ej: fbkkmmncbb...'
							onChange={(e) => handleInputChange("appID", e.target.value)}
						/>
					</div>
					<div className='form-control w-full'>
						<label className='label'>
							<span className='label-text font-semibold'>
								PrivateKey (Vonage)
							</span>
						</label>
						<textarea
							value={privateKey}
							id="privateKey"
							name="privateKey"
							className='input input-bordered w-full'
							placeholder='Ej: BEGIN PRIVATE KEY...'
							onChange={(e) => handleInputChange("privateKey", e.target.value)}
						/>
					</div>
				</div>
			</div>
			{/* Configuracion email */}
			<div className='pt-2'>
				<div className='p-2 justify-center'>
					<p className=' text-base font-semibold'>Parámetros de configuración: MailGun</p>
				</div>
				<div className='grid grid-cols-2 text-black lg:text-sm text-xs gap-4'>
					<div className='form-control w-full'>
						<label className='label'>
							<span className='label-text font-semibold'>
								Dominio (MailGun)
							</span>
						</label>
						<input
							type="text"
							pattern="^([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$"
							value={dominio}
							id="dominio"
							name="dominio"
							className='input input-bordered w-full'
							placeholder='Ej: ejemplo.notificaciones.com'
							onChange={(e) => handleInputChange("dominio", e.target.value)}
						/>
					</div>
					<div className='form-control w-full'>
						<label className='label'>
							<span className='label-text font-semibold'>
								Template (MailGun)
							</span>
						</label>
						<input
							type="text"
							value={template}
							id="template"
							name="template"
							className='input input-bordered w-full'
							placeholder='Ej: templateExample'
							onChange={(e) => handleInputChange("template", e.target.value)}
						/>
					</div>
				</div>
			</div>
			{/* Configuracion shortcut */}
			<div className='pt-2'>
				<div className='p-2 justify-center'>
					<p className=' text-base font-semibold'>Parámetros de configuración: Shortner url</p>
				</div>
				<div className='grid grid-cols-2 text-black lg:text-sm text-xs gap-4'>
					<div className='form-control w-full'>
						<label className='label'>
							<span className='label-text font-semibold'>
								Id dominionio (Shortner url) *
							</span>
						</label>
						<input
							type="text"
							required
							pattern="^\d+$"
							value={idDominio}
							id="iddominio"
							name="dominio"
							className='input input-bordered w-full'
							placeholder='Escriba el ID del dominio'
							onChange={(e) =>{

								if(isNaN(Number(e.target.value))) return false;
								handleInputChange("idDominio", e.target.value)
							}}
						/>
					</div>
				</div>
			</div>
			{/* Botones */}
			<div className='flex gap-2 pt-4 justify-end'>
				<button className='btn btn-sm hover:btn-success hover:text-white' type="submit">
					{
						cargando && (
							<div>
								<span className="loading loading-spinner loading-xs"></span>
							</div>
						)
					}
					Guardar
				</button>
			</div>
		</form>
	);
};

export default EditarEmpresaForm;
